'use client'

import type { ReactNode } from 'react'

import { notifications } from '@mantine/notifications'
import type { NotificationData } from '@mantine/notifications'
import { AlertTriangle, Check, X } from 'lucide-react'

import { DEFAULT_PRIMARY_COLOR } from '@/lib/theme/constants'

export type NotificationOptions = {
  autoClose?: number | false
  color?: string
  icon?: ReactNode
  id?: string
  loading?: boolean
  message?: string | ReactNode
  position?: NotificationData['position']
  title: string
}

const InfoGlyph = () => (
  <span style={{ fontFamily: 'var(--mantine-font-family-monospace)' }}>i</span>
)

export const showSuccess = (options: NotificationOptions) =>
  notifications.show({
    autoClose: 5000,
    color: 'green',
    icon: <Check size={16} />,
    ...options,
    message: options.message ?? null,
  })

export const showError = (options: NotificationOptions) =>
  notifications.show({
    autoClose: 5000,
    color: 'red',
    icon: <X size={16} />,
    ...options,
    message: options.message ?? null,
  })

export const showInfo = (options: NotificationOptions) =>
  notifications.show({
    autoClose: 5000,
    color: 'blue',
    icon: <InfoGlyph />,
    ...options,
    message: options.message ?? null,
  })

export const showWarning = (options: NotificationOptions) =>
  notifications.show({
    autoClose: 5000,
    color: 'yellow.5',
    icon: <AlertTriangle size={16} color='white' />,
    ...options,
    message: options.message ?? null,
  })

export const showLoading = (options: NotificationOptions) =>
  notifications.show({
    autoClose: false,
    color: DEFAULT_PRIMARY_COLOR,
    loading: true,
    withCloseButton: false,
    ...options,
    message: options.message ?? null,
  })

export const cleanNotifications = () => {
  notifications.clean()
}
